import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ToastProvider from './components/controls/Toast/ToastProvider';
import { QRScannerProvider } from './configurations/useQRScanner';
import NetworkProvider from './configurations/auth/publicUsers/useNetwork';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ToastProvider>
    <NetworkProvider>
      <QRScannerProvider>
        <App />
      </QRScannerProvider>
    </NetworkProvider>
  </ToastProvider>
);
